module.exports = __webpack_public_path__ + "img/L1060782.a23a5472.jpg";